<template>
    <div>
        <label>
            {{title}}
        </label>
        <div>
            {{t.prefix}}
            <b-link @click.prevent="$emit('change', options.map(x => x.value))">{{t.select}}</b-link> /
            <b-link @click.prevent="$emit('change', [])">{{t.deselect}}</b-link>
            {{t.suffix}}
        </div>
        <div class="form-control-div" v-if="withFilter">
            <b-form-checkbox-group :checked="checked" :options="options.filter(x => !filter || x.label.toLowerCase().includes(filter.toLowerCase()))" text-field="label" stacked @change="$emit('change', $event)"></b-form-checkbox-group>
        </div>
        <b-form-checkbox-group v-else :checked="checked" :options="options.filter(x => !filter || x.label.toLowerCase().includes(filter.toLowerCase()))" text-field="label" stacked @change="$emit('change', $event)"></b-form-checkbox-group>
        <b-input-group v-if="withFilter">
            <b-input size="sm" v-model="filter"/>
            <template v-slot:append>
                <b-input-group-text><fa-icon icon="search"/></b-input-group-text>
            </template>
        </b-input-group>
    </div>
</template>

<script>
    export default {
        name: "CheckboxList",
        props: {
            title: String,
            options: Array,
            checked: Array,
            withFilter: Boolean,
            t: Object
        },
        model: {
            prop: 'checked',
            event: 'change'
        },
        data: () => ({
            filter: ''
        })
    }
</script>

<style scoped>
    .form-control-div {
        display: block;
        width: 100%;
        padding: 0.375rem 0.75rem;
        font-size: 0.9rem;
        font-weight: 400;
        line-height: 1.6;
        color: #495057;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid #ced4da;
        border-radius: 0.25rem;
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
        overflow-y: auto;
        height: calc(1.44rem * 4);
    }
</style>
